<template>
  <div
    :class="{
      'd-flex align-items-center': dot,
    }"
  >
    <div
      :class="[
        bg,
        {
          border: withBorder,
          'rounded-circle mr-2': dot,
          'w-100  rounded-pill font-weight-bold': !dot,
        },
      ]"
    >
      <div
        class="d-flex align-items-center"
        :class="[
          pillContentClass,
          {
            'justify-content-center': withBorder,
            'p-03': dot,
            'p-2': !dot,
          },
        ]"
      >
        <em v-if="icon" class="fa-xs mr-2" :class="[icon, colorIcon]" />
        <span v-if="!dot" :class="color">{{ text }}</span>
      </div>
    </div>
    <span v-if="dot" class="font-weight-bold" :class="color">{{ text }}</span>
  </div>
</template>

<script>
export default {
  name: 'CustomBalloonLight',
  props: {
    /**
     * Texto que se mostraria en el balloon
     */
    text: {
      type: String,
      required: true,
    },
    /** Si el balloon mostrará un icono debe tener el colorIcon asignado */
    icon: {
      type: String,
      default: () => null,
    },
    /** Clase que mostrará el color del icono */
    colorIcon: {
      type: String,
      default: () => '',
    },
    /** Clase que mostrará el background-color */
    bg: {
      type: String,
      default: () => '',
    },
    /** Color del Texto  */
    color: {
      type: String,
      default: () => '',
    },
    /** Si mostrará los bordes o no en el baloon */
    withBorder: {
      type: Boolean,
      default: () => true,
    },
    dot: {
      type: Boolean,
      default: () => false,
    },
    /** Clase que personaliza el contenido de la balloon */
    pillContentClass: {
      type: String,
      default: () => '',
    },
  },
};
</script>
<style lang="scss" scoped>
.p-03 {
  padding: 0.3rem !important;
}

.bg-green {
  background-color: #a4e5b2 !important;
}
.bg-brown {
  background-color: #d5b899 !important;
}
.bg-yellow {
  background-color: #f8ea80 !important;
}
.bg-pink {
  background-color: #fcc9c8 !important;
}
.bg-violet {
  background-color: #ddb3d7 !important;
}
.bg-chardonnay {
  background-color: #ffc18d !important;
}
.bg-gray {
  background-color: #b5c3bc !important;
  color: white;
}
</style>
